import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { AlertModal, Button } from 'procyon-ui'
import React, { useState } from 'react'
import { FullScreenModal, LoadingFeedback } from 'V2Components'
import { deleteApprovalRequest } from '../../../api'
import { deleteSliceData } from 'infra/redux/sliceHandlers'
import { getHTMLDataTestID } from 'infra/utils'

function DeleteRequestModal({ approvalRequest, showModal, onCancel, afterDelete = null }) {
  const [loading, setLoading] = useState(false)

  const handleApprovalRequestDelete = async () => {
    setLoading(true)
    const req = await deleteApprovalRequest(approvalRequest)
    deleteSliceData(req)
    setLoading(false)
    afterDelete && afterDelete()
  }

  return (
    <div>
      <LoadingFeedback loading={loading} caption='Please wait...' message={'Deleting Approval Request'} />
      <FullScreenModal showModal={showModal}>
        <div className='flex justify-center items-center h-[100%] bg-[#2229455a]'>
          <AlertModal
            description=''
            icon={faExclamationCircle}
            title={`Are you sure you want to delete this request?`}
          >
            <React.Fragment key='.0'>
              <Button 
                data-testid={getHTMLDataTestID('approval', 'button', 'cancel', 'delete-request')}
                onClick={onCancel} variant='gray'>
                Cancel
              </Button>
              <Button 
                data-testid={getHTMLDataTestID('approval', 'button', 'delete', 'delete-request')}
                onClick={handleApprovalRequestDelete} variant='grayRed'>
                Delete
              </Button>
            </React.Fragment>
          </AlertModal>
        </div>
      </FullScreenModal>
    </div>
  )
}

export { DeleteRequestModal }
